import React, { useEffect, useState } from "react";
import AppContext, { AppContextValue } from "./AppContext";
import { toast } from "react-toastify";
import request from "./utils/http";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

const AppContextProvider = (props: any) => {
	const [appContextState, setAppContextState] = useState(AppContextValue.state);

	const navigate = useNavigate();

	useEffect(() => {
		const getUserDetail = async () => {
			let result = await request("GET", "/api/admin/utility/me", null);
			if (result.success && result.data.success) {
				let tmpState = { ...appContextState };
				tmpState.currentUser = result.data;
				tmpState.auth.signingIn = false;
				tmpState.auth.signingOut = false;
				tmpState.auth.email = result.data.email;
				tmpState.auth.name = result.data.name;
				tmpState.settings = result.data.settings;
				tmpState.menu = result.data.items;
				tmpState.auth.permissions = result.data.permissions;
				setAppContextState(tmpState);
			} else {
				toast.error("Unable to log you in.  Try again later.", {
					position: "top-center",
				});
				Auth.signOut();
			}
		};
		getUserDetail();
	}, []);

	const signOut = async () => {
		let tmpState = { ...appContextState };
		tmpState.auth.signingOut = true;
		setAppContextState(tmpState);
		Auth.signOut();
	};

	return (
		<AppContext.Provider
			value={{
				state: appContextState,
				mutate: { signOut },
			}}
		>
			{props.children}
		</AppContext.Provider>
	);
};
export default AppContextProvider;
